module.exports = __webpack_public_path__ + "static/shirtBox-8fa8cbe2c482076958948f7435236df1.png";